import React from 'react';
import { Link } from 'gatsby';
import OutboundLink from '../../components/common/OutboundLink';
import { Button, Container, Col, Row } from 'reactstrap';
import {
  rootPath,
  toFaq,
  toContactUs,
  dentalPostFacebookUrl,
  dentalPostLinkedInUrl,
  dentalPostInstagramUrl,
  toAboutUs,
} from '../../routes';
import { FaFacebook, FaLinkedin, FaInstagram } from 'react-icons/fa';
import LeadNewsletterSubscribe from '../common/LeadNewsletterSubscribe';
import FooterCopyright from './FooterCopyright';
import LocalImage from '../common/images/LocalImage';

const Footer = (props: { childContentOnly?: boolean }) => {
  return (
    <footer
      role="contentinfo"
      className="d-print-none border-top border-light mt-auto"
      style={{ zIndex: 2 }}
    >
      <LeadNewsletterSubscribe />
      <Container fluid className="pt-5">
        <Row className="justify-content-center">
          <Col
            lg="4"
            className="d-flex flex-column align-items-center mx-auto"
            style={{ maxWidth: '350px' }}
          >
            <Link to={rootPath} className="d-flex justify-content-center">
              <LocalImage
                src="dentalpost-logo-on-light-bg.png"
                alt="DentalPost Logo"
                width={148}
                height={95}
                loading="lazy"
              />
            </Link>
            <p className="my-3 text-center">
              The dental industry’s premier and largest online and mobile job
              board
            </p>
            <Container fluid className="px-0">
              <Row className="justify-content-center">
                <Col xs="auto">
                  <Button
                    tag={OutboundLink}
                    color="transparent"
                    href={dentalPostFacebookUrl}
                    className="d-flex justify-content-center align-items-center p-0"
                  >
                    <FaFacebook className="fa-2x text-info" title="facebook" />
                  </Button>
                </Col>
                <Col xs="auto">
                  <Button
                    tag={OutboundLink}
                    color="transparent"
                    href={dentalPostLinkedInUrl}
                    target="_blank"
                    className="d-flex justify-content-center align-items-center p-0"
                  >
                    <FaLinkedin className="fa-2x text-info" title="linked in" />
                  </Button>
                </Col>
                <Col xs="auto">
                  <Button
                    tag={OutboundLink}
                    color="transparent"
                    href={dentalPostInstagramUrl}
                    className="d-flex justify-content-center align-items-center p-0"
                  >
                    <FaInstagram
                      className="fa-2x text-info"
                      title="instagram"
                    />
                  </Button>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
        <Row className="justify-content-center my-4 fw-bold">
          <Col xs="auto">
            <Link to={toAboutUs} className="link-black">
              About Us
            </Link>
          </Col>{' '}
          <Col xs="auto" className="fa-sm px-1">
            |
          </Col>
          <Col xs="auto">
            <Link to={toFaq} className="link-black">
              FAQs
            </Link>
          </Col>
          <Col xs="auto" className="fa-sm px-1">
            |
          </Col>
          <Col xs="auto">
            <Link to={toContactUs} className="link-black">
              Contact Us
            </Link>
          </Col>
          <Col xs="auto" className="fa-sm px-1">
            |
          </Col>
          <Col xs="auto">
            <OutboundLink
              href="https://www.amplify360.com/"
              className="link-black"
            >
              Dental Marketing
            </OutboundLink>
          </Col>
        </Row>
      </Container>
      {!props.childContentOnly && <FooterCopyright />}
    </footer>
  );
};

export default Footer;
